import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import PropTypes from 'prop-types';

const Meetings = ({ meetingList = null, getMeetingList = null, match }) => {
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const Headers = [
    'Subject',
    'Scheduled Date',
    'Scheduled Time',
    'Meeting Status',
    'Action',
  ];
  useEffect(() => {
    if (getMeetingList !== null)
      (async () => {
        setIsLoading(true);
        await getMeetingList(match.params.id);
        setIsLoading(false);
      })();
  }, [getMeetingList]);

  useEffect(() => {
    const tableData = [
      'id',
      'subject',
      'meeting_date',
      'meeting_time',
      'status',
    ];

    const data =
      meetingList.length &&
      meetingList.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Actions: {
              name: 'View Details',
              link: `${baseUrl}/meeting-details-scheduled/${element.id}`,
              siteId: match?.params?.id,
            },
          }
        )
      );
    meetingList.length && data && setListData(data);
  }, [meetingList]);

  const headerBtns = () => {
    return (
      <Fragment>
        <Link
          to={`${baseUrl}/schedule-meeting/${match?.params?.id}`}
          className="btn btn-primary"
        >
          {localization.scheduleMeeting}
          <img src={Images?.ArrowRight} alt="" />
        </Link>
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.meetingHistory}
      Buttons={headerBtns}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/site-listing`}
    >
      <TableSection
        data={listData}
        headers={Headers}
        detailList={meetingList}
        isId={false}
      />
    </Layout>
  );
};

Meetings.propTypes = {
  meetingList: PropTypes.any,
  getMeetingList: PropTypes.func,
  match: PropTypes.any,
};

export default Meetings;
